import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AuthState {
  currentUser: {
    [key: string]: any,
  };
  isAuthenticated: boolean;
  error: string;
}

const initialState: AuthState = {
  currentUser: {},
  isAuthenticated: false,
  error: '',
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<any>) => ({
      ...state,
      currentUser: action.payload,
      isAuthenticated: true,
    }),
    logout: (state) => ({
      ...state,
      isAuthenticated: false,
      currentUser: {},
      error: '',
    }),
    updateFranchiseId: (state, action: PayloadAction<number>) => {
      // eslint-disable-next-line no-param-reassign
      state.currentUser = {
        ...state.currentUser,
        franchiseId: action.payload,
      };
    },
  },
});

export const {
  login,
  logout,
  updateFranchiseId,
} = authSlice.actions;

export default authSlice.reducer;
